import { Decoration, DecorationSet } from '@tencent/exeditor3-core';
import '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
const defaultOption = {
    attributesForEmpty: {
        style: 'background-color: #fbfbfb',
    },
};
export class ParagraphCheckPlugin {
    constructor(option = {}) {
        this.name = 'paragraphCheck';
        this.isEnabled = false;
        this.enabled = (isEnabled) => {
            if (typeof isEnabled === 'boolean') {
                this.isEnabled = isEnabled;
                this.editor.refreshPlugin(this);
            }
            return this.isEnabled;
        };
        this.opt = {
            ...defaultOption,
            ...option,
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            commands: {
                enabled: this.enabled,
            },
            decorate: (doc) => {
                if (!this.isEnabled) {
                    return null;
                }
                return this.createCheckDecorations(doc);
            },
        };
    }
    renderToolbarItem() {
        const btn = document.createElement('exeditor-toolbar-button');
        Object.assign(btn, {
            label: this.editor.t('段落检查'),
            active: this.enabled(),
            onclick: () => {
                this.editor.focus();
                btn.active = this.enabled(!this.enabled());
            },
        }).appendChild(createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.paragraphCheckIcon),
        }));
        return btn;
    }
    createCheckDecorations(doc) {
        const decos = [];
        this.lint(doc).forEach((prob) => {
            decos.push(Decoration.node(prob.from, prob.to, this.opt.attributesForEmpty));
        });
        return DecorationSet.create(doc, decos);
    }
    lint(doc) {
        const result = [];
        doc.descendants((node, pos) => {
            if (node.type.name === 'paragraph') {
                if (!node.textContent.trim()) {
                    result.push({ from: pos, to: pos + node.nodeSize });
                }
                return false;
            }
            return undefined;
        });
        return result;
    }
}
//# sourceMappingURL=index.js.map